// extracted by mini-css-extract-plugin
module.exports = {"container":"LS-PhV2lPbX9GtZkiti8r"};